var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlay1 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9387 14.1685L8.11159 21.6747C7.7726 21.888 7.39092 22 7.00279 22C6.61467 22 6.23298 21.888 5.894 21.6747C5.56141 21.4504 5.2859 21.1328 5.09421 20.7529C4.90252 20.3729 4.80116 19.9435 4.79999 19.5063V4.49368C4.80116 4.05648 4.90252 3.62705 5.09421 3.24709C5.2859 2.86713 5.56141 2.54955 5.894 2.3252C6.23298 2.11192 6.61467 1.99997 7.00279 1.99997C7.39092 1.99997 7.7726 2.11192 8.11159 2.3252L19.9387 9.83149C20.2765 10.0509 20.5571 10.3668 20.7522 10.7475C20.9473 11.1282 21.05 11.5602 21.05 12C21.05 12.4397 20.9473 12.8717 20.7522 13.2524C20.5571 13.6331 20.2765 13.9491 19.9387 14.1685Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlay1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Play1.f53e7d40ee96a942e2f999e2f23fc75e.svg";